import { Component } from 'react';
import Raven from 'raven-js';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import { H4 } from 'foundations-components/transitional/components/H4';
import { View } from 'foundations-components/components/View';
import { Text } from 'foundations-components/components/Text';
import { NOT_FOUND, USER_NOT_FOUND, MEETING_PREVIOUSLY_CANCELLED, REBOOK_CONFLICT, EXCHANGE_CANCELLATION } from 'MeetingsLib/constants/errors';
import { getLongDisplayName } from 'MeetingsLib/utils/utils';
import { Button } from 'foundations-components/transitional/components/Button';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default class Error extends Component {
  constructor(...args) {
    super(...args);
    this.handleReloadPage = () => {
      const {
        meetingRescheduleFailed,
        meetingRescheduleError
      } = this.props;
      const retryRebook = meetingRescheduleError === REBOOK_CONFLICT;
      if (meetingRescheduleFailed && !retryRebook) {
        const route = document.location.origin + document.location.pathname;
        document.location = route;
      } else {
        document.location.reload();
      }
    };
    this.renderDescription = message => {
      return /*#__PURE__*/_jsx(View, {
        maxInlineSize: "416px",
        marginInline: "auto",
        children: /*#__PURE__*/_jsx(Text, {
          as: "p",
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: message
          })
        }, "description")
      });
    };
    this.renderEmail = () => {
      const {
        profile
      } = this.props;
      return /*#__PURE__*/_jsx(View, {
        as: "div",
        children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: "error.emailLink_jsx",
          options: {
            fullName: getLongDisplayName(profile),
            emailAddress: profile.email,
            linkProps: {
              href: `mailto:${profile.email}`,
              use: 'blue'
            }
          },
          elements: {
            Link
          }
        })
      }, "email");
    };
    this.renderRetryButton = desiredMessage => {
      const {
        meetingRescheduleError
      } = this.props;
      const retryRebook = meetingRescheduleError === REBOOK_CONFLICT;
      const message = desiredMessage || 'error.button';
      return /*#__PURE__*/_jsx(View, {
        as: "div",
        marginBlockStart: "900",
        marginBlockEnd: "1200",
        "data-test-id": "error-button-container",
        children: /*#__PURE__*/_jsx(Button, {
          use: retryRebook ? 'primary' : 'danger',
          onClick: this.handleReloadPage,
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: message
          })
        })
      }, "retry");
    };
    this.renderHeader = message => {
      return /*#__PURE__*/_jsx(H4, {
        marginBlockEnd: "200",
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: message
        })
      }, "header");
    };
    this.renderCreateErrorWithReload = () => {
      return /*#__PURE__*/_jsxs(ErrorMessage, {
        title: this.renderHeader('error.general.header'),
        children: [this.renderDescription('error.general.retryDescription'), this.renderRetryButton(), this.renderEmail()]
      });
    };
    this.renderRescheduleErrorWithReload = (descriptionMessage, buttonMessage) => {
      const desiredDescription = descriptionMessage || 'error.general.retryDescription';
      return /*#__PURE__*/_jsxs(ErrorMessage, {
        title: this.renderHeader('error.general.header'),
        children: [this.renderDescription(desiredDescription), this.renderRetryButton(buttonMessage), this.renderEmail()]
      });
    };
    this.renderRescheduleConflict = () => {
      const buttonMessage = 'error.buttonRebookConflict';
      const desiredDescription = 'error.general.rebookConflictError';
      return /*#__PURE__*/_jsxs(ErrorMessage, {
        title: this.renderHeader('error.general.header'),
        illustration: "meetings",
        children: [this.renderDescription(desiredDescription), this.renderRetryButton(buttonMessage)]
      });
    };
    this.renderInactiveState = () => {
      const {
        NotFoundMarker
      } = this.props;
      return /*#__PURE__*/_jsxs(ErrorMessage, {
        type: "notFound",
        title: this.renderHeader('error.downgraded.header'),
        children: [this.renderDescription('error.downgraded.description'), this.renderEmail(), /*#__PURE__*/_jsx(NotFoundMarker, {})]
      });
    };
    this.renderLinkNotFound = () => {
      const {
        NotFoundMarker
      } = this.props;
      return /*#__PURE__*/_jsxs(ErrorMessage, {
        "data-test-id": "link-not-found",
        type: "notFound",
        title: this.renderHeader('error.general.header'),
        children: [this.renderDescription('error.general.genericDescription'), /*#__PURE__*/_jsx(NotFoundMarker, {})]
      });
    };
    this.renderError = () => {
      const {
        ErrorMarker
      } = this.props;
      Raven.captureMessage('Error Marker rendered', {
        extra: {
          state: this.props
        },
        level: 'warning'
      });
      return /*#__PURE__*/_jsxs(ErrorMessage, {
        children: [this.renderDescription('error.general.errorDescription'), /*#__PURE__*/_jsx(ErrorMarker, {})]
      });
    };
    this.renderRescheduleFailure = () => {
      const {
        meetingRescheduleError,
        profile
      } = this.props;
      const rebookErrorMessage = 'error.general.rebookGeneralError';
      const rebookButtonMessage = 'error.buttonRebook';
      switch (meetingRescheduleError) {
        case MEETING_PREVIOUSLY_CANCELLED:
          return this.renderRescheduleErrorWithReload(rebookErrorMessage, rebookButtonMessage);
        case REBOOK_CONFLICT:
          return this.renderRescheduleConflict();
        case EXCHANGE_CANCELLATION:
          Raven.captureMessage(meetingRescheduleError, {
            extra: {
              profile
            },
            level: 'error'
          });
          return this.renderCreateErrorWithReload();
        default:
          return this.renderCreateErrorWithReload();
      }
    };
    this.renderDifferentMessages = () => {
      const {
        meetingCreationFailed,
        bookInfoFailed,
        bookInfoError,
        meetingsUserFetchSuccess,
        meetingRescheduleFailed
      } = this.props;
      if (meetingRescheduleFailed) {
        return this.renderRescheduleFailure();
      }
      if (meetingCreationFailed) {
        return this.renderCreateErrorWithReload();
      }
      if (bookInfoFailed && (bookInfoError === NOT_FOUND || bookInfoError === USER_NOT_FOUND)) {
        if (meetingsUserFetchSuccess) {
          return this.renderInactiveState();
        }
        return this.renderLinkNotFound();
      }
      return this.renderError();
    };
  }
  componentDidMount() {
    if (this.props.meetingCreationFailed) {
      this.props.onFailure();
    }
  }
  render() {
    return /*#__PURE__*/_jsx(View, {
      padding: "1500",
      marginInline: "auto",
      textAlign: "center",
      children: this.renderDifferentMessages()
    });
  }
}